import { COLORS } from '@constants';

export const CHART_OPTIONS = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: {
            top: 56,
            bottom: 0,
            left: 16,
            right: 16
        }
    },
    elements: {
        line: {
            label: '',
            tension: 0.4,
            borderWidth: 4
        },
        point: {
            radius: 0,
            hoverRadius: 8,
            hoverBorderWidth: 4,
            backgroundColor: '#fff'
        }
    },
    plugins: {
        tooltip: {
            displayColors: false,
            backgroundColor: COLORS.$white,
            borderColor: COLORS.$gray20Black,
            borderWidth: 1,
            intersect: false,
            padding: 16,
            caretSize: 0,
            xAlign: 'left',
            yAlign: 'bottom',
            bodyColor: COLORS.$gray100Black,
            titleColor: COLORS.$gray100Black,
            titleFont: {
                size: 14
            },
            bodyFont: {
                size: 14,
                weight: 'medium'
            },
            usePointStyle: true,
            pointStyle: '',
            callbacks: {
                title: (context) => {
                    return context[0].dataset.dates[context[0].dataIndex];
                }
            }
        },
        legend: {
            display: false
        },
        title: {
            display: false
        }
    },
    interaction: {
        intersect: false
    },
    scales: {
        x: {
            grid: {
                display: true,
                color: COLORS.$gray15Black,
                lineWidth: 1,
                drawBorder: false
            },
            display: true,
            title: {
                display: false
            }
        },
        y: {
            title: {
                display: false
            },
            position: 'left',
            display: false,
            offset: true,
            grid: {
                drawOnChartArea: true
            }
        }
    }
};
